const WAF_ACTION_HEADER = 'x-amzn-waf-action';
const WAF_CHALLENGE_STATUS = 202;

export const AWS_WAF_SECURITY_CHECK_MESSAGE = "We couldn't verify your request. Please try again.";

function wafActionFromHeaders(headers?: Record<string, unknown>): string | undefined {
  const value = headers?.[WAF_ACTION_HEADER];
  return typeof value === 'string' ? value.toLowerCase() : undefined;
}

export function isAwsWafInterruption(status?: number, headers?: Record<string, unknown>): boolean {
  const wafAction = wafActionFromHeaders(headers);
  return status === WAF_CHALLENGE_STATUS || wafAction === 'challenge';
}

export function isAwsWafResponseError(error: unknown): boolean {
  if (!(error && typeof error === 'object' && 'response' in error)) {
    return false;
  }

  const response = error.response as {
    status?: number;
    headers?: Record<string, unknown>;
  };

  return isAwsWafInterruption(response.status, response.headers);
}
